import React from "react";
import TinyMCEEditor from "../ckEditor/TinyMCEEditor";

function Richtext(props) {
  return (
    <div key={"RichTextComp_" + props.identity}>
      <div className="reach-text">
        <div className="grid grid-cols-12 gap-6 mt-10 mb-10 border border-[#757575]">
          <div className="filter-types col-span-12 font-bold border-b border-[#757575] bg-[#f0f0f0] px-7 py-3 relative">
            <h2 className="filter-lable  font-medium theme-color">
              Rich Text
            </h2>

            <div className="close-icon-btn absolute top-[50%] right-[10px] translate-y-[-50%]">
              {props.componentDetails.componentName === 'CyberCatalogue_' || props.componentDetails.componentName === 'CyberPlaybook_' || props.componentDetails.componentName === 'CyberMission_1' || props.componentDetails.componentName === 'CyberMission_2' || props.componentDetails.componentName === 'CookiesPolicy_1' || props.componentDetails.componentName === 'PrivacyStatement_1' || props.componentDetails.componentName === 'TermsofUse_1'?
                ""
                : <button
                  className="h-7 w-7 flex items-center justify-center text-[#757575] hover:text-[#3a3a3a] rounded-full border-2 border-[#757575] close-button"
                  onClick={() => props.removeComponent()}
                >
                  <div className="sr-only">Close</div>
                  <svg className="w-4 h-4 fill-current">
                    <path d="M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z" />
                  </svg>
                </button>
              }
            </div>


          </div>
          <div className="filter-types col-span-12 p-8">
            <div className="grid grid-cols-12 gap-6 w-full">
              <div className="xl:col-span-5 lg:col-span-5 sm:col-span-12 input-sec-texts">
                <div className="flex items-center">
                  <div className="w-[60%] mr-4 pt-1">
                    <h2 className="filter-lable  font-medium theme-color">
                      Component Unique Id :
                    </h2>
                  </div>
                  <div className="w-[40%]">
                    <input
                      id="default"
                      name="componentId"
                      className="w-full outline-none appearance-none form-input rounded-none bg-zinc-100"
                      type="text"
                      value={props.componentDetails.componentId}
                      onChange={(event) => props.handleChange(event, props.identity)}
                      disabled={true}
                    />
                  </div>
                </div>
              </div>
              <div className="xl:col-span-7 lg:col-span-7 sm:col-span-12 input-sec-texts">
                <div className="flex items-center">
                  <div className="w-[40%] mr-4 pt-1">
                    <h2 className="filter-lable  font-medium theme-color">
                      Component Name :
                    </h2>
                  </div>
                  <div className="w-[60%]">
                    <input
                      id="default"
                      name="componentName"
                      className={`w-full outline-none appearance-none form-input rounded-none ${(props.componentDetails.componentName) ? 'bg-zinc-100' : ''}`}
                      type="text"
                      value={props.componentDetails.componentName}
                      onChange={(event) => props.handleChange(event, props.identity)}
                      disabled={(props.componentDetails.componentName) ? true : false}
                    // disabled={true}
                    />
                  </div>
                </div>
              </div>
              <div className="col-span-12 mt-5">
                <div className="post-details">
                  <TinyMCEEditor
                    key={"RichTextEditor"}
                    onTinyEceEditorChange={(data, editor) => { props.setEditorData(data, props.identity, editor); }}
                    data={props.componentDetails.componentContent}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Richtext;
